import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import {createTheme, ThemeProvider} from "@mui/material/styles";
import {Provider} from "react-redux";
import {PersistGate} from "redux-persist/integration/react";
import {persistor, store} from "./redux/store";
import Login from "./views/auth/Login";
import Aside from "./views/v2/Components/Aside/Aside";
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Home from "./views/v2/Main/Home";
import Logout from "./views/auth/Logout";
import CSV from "./views/v2/Main/Certificates/CSV";
import UserList from "./views/v2/users/UserList";
import UserForm from "./views/v2/users/UserForm";
import SchoolList from "./views/v2/schools/SchoolList";
import SchoolForm from "./views/v2/schools/SchoolForm";
import DepartmentList from "./views/v2/departments/DepartmentList";
import DepartmentForm from "./views/v2/departments/DepartmentForm";
import EventForm from "./views/v2/events/EventForm";
import CertificateList from "./views/v2/certificates/CertificateList";
import CertificateForm from "./views/v2/certificates/CertificateForm";
import EventFormStep2 from "./views/v2/events/EventFormStep2";
import CreateCertificates from "./views/main/certificates/CreateCertificates";
import PublicCertificateViewer from "./views/main/certificates/PublicCertificateViewer";
import TemplatesList from './views/v2/templates/templatesList';
import UpCommingEvents from './views/v2/events/UpComingEvents';
import PastEventInfo from './views/v2/events/PastEventInfo';
import PastEventView from './views/v2/events/PastEventView';
import ChildEvent from "./views/v2/events/ChildEvent";
import Registration from "./views/v2/Registration/registration";
import RegistrationList from "./views/v2/Registration/registrationList";
import VerificationPage from "./views/v2/Registration/VerificationPage";
import Report from "./views/v2/TemplateReports/Report";
import EventReport from "./views/v2/Components/PDF/EventReport";
import PastEvent from "./views/v2/events/PastEvent";
import Header from "./views/v2/Components/Header/Header";
import HomePage from "./views/v2/HomePage/HomePage";
import EventDetails from "./views/v2/EventDetail/EventDetails";
import IicReport from "./views/v2/Components/PDF/IicReport";
import NewIicReport from "./views/v2/Components/PDF/NewIicReport";
import RiseEventReport from "./views/v2/Components/PDF/RiseEventReport";
import CertificateReport from "./views/v2/certificateReport/certificateReport";
import { useEffect } from "react";
import DepartmentReport from "./views/v2/TemplateReports/departmentReport";
import TemplateReports from "./views/v2/TemplateReports/TemplateReports";
import RoleWiseReport from "./views/v2/TemplateReports/RoleWiseReport";
import AdminReport from "./views/v2/TemplateReports/AdminReport";
import MediaCollection from "./views/v2/mediaCollection/MediaCollection";
import MediaDepartmentList from "./views/v2/mediaCollection/MediaDepartmentList";
import BlankTemplate from "./views/v2/blankTemplate/BlankTemplate";
import Layout from "./views/v2/blankTemplate/Layout";
import OtherTemplate from "./views/v2/blankTemplate/Other";
import MunRegistration from "./views/v2/MunRegistration/MUNRegistration";


const theme = createTheme();

function App() {
    useEffect(() => {
          // Create a script element
    const script = document.createElement('script');

    // Set the source attribute to the URL of the script you want to import
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-3NFSR9BSLK';

    // Append the script element to the document body
    document.body.appendChild(script);

    // Clean up function to remove the script element when the component unmounts
    return () => {
      document.body.removeChild(script);
    };
    },[]);
    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        function gtag(){window.dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', 'G-3NFSR9BSLK');
      });
    return <ThemeProvider theme={theme}>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <Router>
                    <Routes>
                        <Route path="/home" exact element={<Home/>}/>
                        <Route path="/auth/login" exact element={<Login/>}/>
                        <Route path="/munRegistration" exact element={<MunRegistration/>}/>
                        <Route path="/logout" exact element={<Logout/>}/>
                        <Route path="/certificate/:id" exact element={<PublicCertificateViewer/>}/>
                        <Route path="/verification/:id" exact element={<VerificationPage/>}/>
                        <Route path="/eventReport/:id" exact element={
                        <div className="wrapper">
                            {/* <Aside />  */}
                            <EventReport />
                            </div>} />
                        
                        <Route path="/iicReport/:id" exact element={
                            <div className="wrapper">
                            <IicReport />
                            </div>
                        }/>

                        <Route path="/newiicReport/:id" exact element={
                            <div className="wrapper">
                            <NewIicReport />
                            </div>
                        }/>

                        <Route path="/riseEventReport/:id" exact element={
                            <div className="wrapper">
                            <RiseEventReport />
                            </div>
                        }/>

                        <Route path="/templateReports/:id" exact element={
                            <div className="wrapper">
                                 <Aside/>
                                <TemplateReports />
                            </div>
                        }/>

                        <Route path="/certificates/csv" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/>
                                <CSV/>
                            </div>
                        }/>

                        <Route path="/" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                {/* <Aside/> */} 
                                <HomePage />
                            </div>
                        }/>

                        <Route path="/EventDetail/:id" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                {/* <Aside/> */} 
                                <EventDetails />
                            </div>
                        }/>

                        <Route path="/adminRepo" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/> 
                                <AdminReport />
                            </div>
                        }/>

                        <Route path="/registration/:id" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/>
                                <RegistrationList/>
                            </div>
                        }/>

                        <Route path="/Report" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/>
                                <CertificateReport/>
                            </div>
                        }/>

                        <Route path="/ReportRoleWise" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/>
                                <RoleWiseReport/>
                            </div>
                        }/>

                        <Route path="/users" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/>
                                <UserList/>
                            </div>
                        }/>
                        <Route path="/brands" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/>
                                <SchoolList/>
                            </div>
                        }/>
                        <Route path="/departments" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/>
                                <DepartmentList/>
                            </div>
                        }/>
                        {/* <Route path="/templates" exact element={
                            <div className="wrapper">
                                <Header/>
                                <Aside/>
                                <EventList/>
                            </div>
                        }/> */}
                        <Route path="/templates/:id/certificates" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/>
                                <CertificateList/>
                            </div>
                        }/>
                        <Route path="/certificates" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/>
                                <CreateCertificates/>
                            </div>
                        }/>
                        <Route path="/users/:id" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/>
                                <UserForm/>
                            </div>
                        }/>
                        <Route path="/brands/:id" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/>
                                <SchoolForm/>
                            </div>
                        }/>
                        <Route path="/certificates/:id" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/>
                                <CertificateForm/>
                            </div>
                        }/>
                        <Route path="/templates/:id" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/>
                                <EventForm/>
                            </div>
                        }/>
                        <Route path="/registration/:eventId/:id" exact element={
                            <div className="wrapper">
                                <Header/>
                                {/* <Aside/> */}
                                <Registration/>
                            </div>
                        }/>
                        <Route path="/ChildEvent/:id" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/>
                                <ChildEvent/>
                            </div>
                        }/>
                        <Route path="/templates_2/:id/:templateId" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/>
                                <EventFormStep2/>
                            </div>
                        }/>
                        <Route path="/templateLayouts" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/>
                                <Layout/>
                            </div>
                        }/>
                        <Route path="/departments/:id" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/>
                                <DepartmentForm/>
                            </div>
                        }/>
                        <Route path="/eventTemplates/:id" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/>
                                <TemplatesList/>
                            </div>
                        }/>
                        <Route path="/pastEventTemplates/:id" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/>
                                <TemplatesList/>
                            </div>
                        }/>
                        {/* <Route path="/postEvent" exact element={
                            <div className="wrapper">
                                <Header/>
                                <Aside/>
                                <PastEvent/>
                            </div>
                        }/> */}
                        <Route path="/PostEvent/:templateId" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/>
                                <PastEventInfo/>
                            </div>
                        }/>
                        <Route path="/PostEventInformation/:templateId" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/>
                                <PastEventView/>
                            </div>
                        }/>
                        <Route path="/UpCommingEvents" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/>
                                <UpCommingEvents/>
                            </div>
                        }/>
                        <Route path="/PastEvents" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside />
                                <PastEvent />
                            </div>
                        }/>
                        <Route path="/Report/:id/:eventId" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/>
                                <Report/>
                            </div>
                        }/>
                        <Route path="/Report/:id/:eventId/:type" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/>
                                <Report/>
                            </div>
                        }/>
                         <Route path="/mediaCollection" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/>
                                <MediaDepartmentList/>
                            </div>
                        }/>
                        <Route path="/mediaCollection/:department" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/>
                                <MediaCollection/>
                            </div>
                        }/>
                         <Route path="/Report/:id/:eventId/:type" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/>
                                <Report/>
                            </div>
                        }/>
                        <Route path="/DepReport" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/>
                                <DepartmentReport/>
                            </div>
                        }/>
                        <Route path="/blankTemplate" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/>
                                <BlankTemplate />
                            </div>
                        }/>
                        <Route path="/OtherTemplate" exact element={
                            <div className="wrapper">
                                {/* <Header/> */}
                                <Aside/>
                                <OtherTemplate />
                            </div>
                        }/>
                    </Routes>
                </Router>
            </PersistGate>
        </Provider>
    </ThemeProvider>
}

export default App;
